"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var ReverifyEmailAction;
(function (ReverifyEmailAction) {
    ReverifyEmailAction.ON_REVERIFY_EMAIL_FORM_SUBMIT = 'ON_REVERIFY_EMAIL_FORM_SUBMIT';
    ReverifyEmailAction.SET_REVERIFY_EMAIL_FORM_LOADING = 'SET_REVERIFY_EMAIL_FORM_LOADING';
    ReverifyEmailAction.onReverifyEmailFormSubmit = typesafe_actions_1.createAction(ReverifyEmailAction.ON_REVERIFY_EMAIL_FORM_SUBMIT, function (resolve) {
        return function (forgotPasswordFields) {
            return resolve(forgotPasswordFields);
        };
    });
    ReverifyEmailAction.setLoading = typesafe_actions_1.createAction(ReverifyEmailAction.SET_REVERIFY_EMAIL_FORM_LOADING, function (resolve) { return function (state) { return resolve(state); }; });
})(ReverifyEmailAction || (ReverifyEmailAction = {}));
exports.default = ReverifyEmailAction;
